<template>
    <div>
    <st_header_cop :default_index="''"></st_header_cop>
    <div class="index_page contanic_no_lock" >
      <br>
      <br>
      <h1>
        {{dataDetail.title}}
      </h1>
      <div class="sub_title">
          {{dataDetail.content_type}} | {{dataDetail.createTime}}
      </div>
      <br><br><br>

      <div v-html="dataDetail.content_detail" class="detail_div ql-editor"></div>

      <!-- {{dataDetail.content_detail}} -->
    </div>
    <st_footer_cop></st_footer_cop>
  </div>
</template>

<script>
import st_header from "../components/header_main.vue"
import st_footer from "../components/footer.vue"
import { getContentInfo } from '../utils/api'
export default {
  name:"index",
  components:{
    st_header_cop : st_header,
    st_footer_cop : st_footer,
  },
  data() {
    return {
      id_val:-1,
      dataDetail:[],
    };
  },
  methods:{
    getData(id){
      let that = this;
      that.load.$emit('loading', true);
      getContentInfo(id)
      .then(function(res){
        //console.log(res)
        if(res.code===1000){
          let reg = new RegExp( '<img' , "g" )
          res.data.content_detail = res.data.content_detail.replace(reg,"<img style='max-width:100%'")
          that.dataDetail = res.data
          //alert(that.dataDetail.content_detail)
          //that.dataDetail.content_detail=
          setTimeout(function(){
            that.load.$emit('loading', false);
          },1000)
        }else{
          console.error("error")
        }
      }).catch(function(err){
        console.log(err)
      })
    },
    // replaceStr(str){
    //   var newstring = str;
    //   while(newstring.indexOf("<img") > 0) 
    //   {
    //     newstring = newstring.replace("<img","<img style='width:100%'");
    //   }
    //   return newstring;
    // }
  },
  created(){
    this.id_val = this.$route.query.id;
    this.getData(this.id_val);
  }

}
</script>

<style scoped lang="scss">
@import url('../assets/quill/quill.bubble.css');
@import url('../assets/quill/quill.core.css');
@import url('../assets/quill/quill.snow.css');
.index_page{
  background: rgba(255,255,255,0.9);
  margin-left: 10%;
  margin-right: 10%;
  padding: 5%;
  text-align: left;
}
.detail_div{
  width: 100%;
  text-align: left;
  min-height: 40vh;
}
.sub_title{
  padding-right: 2%;
  text-align: right;
}


.ql-editor {
	background-color: #fff;
	.ql-snow {
		line-height: 22px !important;
	}

	.el-upload,
	#quill-upload-btn {
		display: none;
	}

	.ql-snow {
		border: 1px solid #dcdfe6;
	}

	.ql-snow .ql-tooltip[data-mode="link"]::before {
		content: "请输入链接地址:";
	}

	.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
		border-right: 0px;
		content: "保存";
		padding-right: 0px;
	}

	.ql-snow .ql-tooltip[data-mode="video"]::before {
		content: "请输入视频地址:";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item::before {
		content: "14px";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
		content: "10px";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
		content: "18px";
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
		content: "32px";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item::before {
		content: "文本";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
		content: "标题1";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
		content: "标题2";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
		content: "标题3";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
		content: "标题4";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
		content: "标题5";
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
		content: "标题6";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item::before {
		content: "标准字体";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
		content: "衬线字体";
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
		content: "等宽字体";
	}
}
</style>


// WEBPACK FOOTER //
// src/view/th_detail.vue